export default __webpack_public_path__ + "static/media/twitter-inactive.6ebb6e45.svg";